import { GenericService } from '@/services/api/generic.service';
import { FormSubmission } from '@/models';

export class AnonymousParticipantFormSubmissionService extends GenericService<FormSubmission> {

  constructor(participantId: string) {
    super(`v1/anonymous-participants/${participantId}/form-submissions`);
  }
}
